const configuredHttpsUrl = (value) => {
    if (!value) {
        return null
    }

    try {
        const url = new URL(value)
        return url.protocol === 'https:' ? url.toString() : null
    } catch {
        return null
    }
}

export const supportUrl =
    configuredHttpsUrl(process.env.REACT_APP_SUPPORT_URL) ||
    'https://t.me/minecards_help'
export const communityUrl =
    configuredHttpsUrl(process.env.REACT_APP_COMMUNITY_URL) ||
    'https://t.me/minecards_app'
export const androidDownloadUrl = configuredHttpsUrl(
    process.env.REACT_APP_ANDROID_DOWNLOAD_URL
)
export const applicationUrl =
    configuredHttpsUrl(process.env.REACT_APP_PRIMARY_ORIGIN) ||
    'https://minecards.app/'
export const ideasUrl =
    configuredHttpsUrl(process.env.REACT_APP_IDEAS_URL) ||
    'https://minecards.featurebase.app/'
export const canonicalApplicationUrl = 'https://minecards.app/'

export const redirectToCanonicalApplication = () => {
    window.location.assign(canonicalApplicationUrl)
}

export const openExternalUrl = (url) => {
    if (!url) {
        return false
    }

    window.open(url, '_blank', 'noopener,noreferrer')
    return true
}
